import script from "./HubAiSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./HubAiSidebar.vue?vue&type=script&setup=true&lang=js"

import "./HubAiSidebar.vue?vue&type=style&index=0&id=8288749e&lang=css"

const __exports__ = script;

export default __exports__